import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-ovoo',
  templateUrl: './ovoo.component.html',
  styleUrls: ['./ovoo.component.scss']
})
export class OvooComponent implements OnInit {

  introduce:any;
  ibg:any;
  master:any;
  saList:any;
  url = this.api.url;
  constructor(private api: ApiService) { }

  ngOnInit(): void {
    this.GetIntroduce();
    this.GetMaster();
    this.GetMTaxonomy();
  }
  GetIntroduce() {
    this.api.GetIntroduce().subscribe (
      data => {
        this.introduce = data;
        this.ibg = this.url + data.image;
      }
    )
  }
  GetMaster() {
    this.api.GetMaster().subscribe (
      data => this.master = data
    )
  }
  GetMTaxonomy() {
    this.api.GetMTaxonomy('NcmiiCbcga').subscribe (
      data => this.GetSirisAjillagaList(data[2].taxonomyId)
    )
  }
  GetSirisAjillagaList(id: any) {
    this.api.GetSirisAjillagaList(id).subscribe(
      data => this.saList = data
    )
  }
}
